import React, { useState } from "react"
import Header from "./header"
import NavLinks from "./navLinks"

const Nav = props => {
  const [isOpen, setIsOpen] = useState(false)
  let projects = props.projects

  const openMenu = () => {
    isOpen ? setIsOpen(false) : setIsOpen(true)
  }

  return (
    <div id="nav">
      <div class="header-wrapper">
        <Header title={props.title} logo={props.logo} />
        <button class="dropdown-button" onClick={openMenu}>
          <div class={ isOpen ? "arrow flip" : "arrow"}>
            ↓
          </div>
        </button>
      </div>

      <NavLinks isOpen={isOpen} projects={projects} location={props.location} />
    </div>
  )
}

export default Nav
